module.exports = __webpack_public_path__ + "static/media/map-pin.9fc777d8.png";